import { render, staticRenderFns } from "./BizDirectInvoice.vue?vue&type=template&id=6f7a9e61&"
import script from "./BizDirectInvoice.vue?vue&type=script&lang=js&"
export * from "./BizDirectInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports